module.exports = __webpack_public_path__ + "img/mask.8ba3c5f1.png";